import React from "react";
import Skeleton from "react-loading-skeleton";

const InvestisseurCalendrierRemboursementTableSkeleton = () => {
    return(
        <div className="col-md-12 as-col-table-container">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col"  style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Projets</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Score</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Taux</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Prêtés</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Perçus</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Provisions</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >En cours</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default InvestisseurCalendrierRemboursementTableSkeleton;